<!-- 戻るボタン -->
<div class="mb-3">
  <button
    pButton
    type="button"
    (click)="goBack()"
    class="p-button-text p-button-sm">
    <i
      class="pi pi-arrow-left"
      aria-hidden="true"></i>
    戻る
  </button>
</div>

<!-- 閉じたら配列から外す。track を $index にすると、閉じて非表示になった p-message が次のメッセージに使い回される -->
@for (m of messages; track m) {
  <p-message
    [severity]="m.severity"
    [closable]="true"
    (onClose)="messages.splice($index, 1)"
    class="mb-3">
    <b>{{ m.summary }}</b>
    {{ m.detail }}
  </p-message>
}

<!-- SP-APIトークン失効時の再認証リンク -->
@if (messages.length > 0 && messages[0].severity === 'error' && messages[0].summary === 'SP-APIトークンが無効です') {
  <div class="mb-3">
    <a [href]="getSpapiReconnectLink()">
      <p-button
        label="Amazon 連携を再実行する"
        icon="pi pi-link"
        styleClass="p-button-danger"></p-button>
    </a>
  </div>
}

<p-panel
  header="Amazon追跡 - 一括登録"
  [toggleable]="false">
  <div class="grid">
    <div class="col-12">
      <p class="mb-3">
        ASIN / メモ / 仕入れ成功確率 を改行区切りの TSV または CSV で貼り付けてください。
        <br />
        1 行に 1 商品、列区切りはタブまたはカンマです。メモ・確率は省略可 (空欄)、確率は 0-100 の整数です。
        <br />
        既に登録済みの ASIN はスキップされます (件数と ASIN 一覧が表示されます)。
      </p>

      <div class="field">
        <label for="bulk-input">入力 (ASIN / メモ / 確率)</label>
        <textarea
          id="bulk-input"
          pInputTextarea
          [(ngModel)]="inputText"
          rows="12"
          class="w-full"
          placeholder="B08N5WRWNW&#9;仕入れ候補&#9;80&#10;B07XJ8C8F5&#9;&#9;50&#10;B09KMVNY9J&#10;# 先頭が # の行はコメントとして無視されます"
          [disabled]="isLoading"></textarea>
      </div>

      <div class="flex gap-2 mt-3">
        <button
          pButton
          type="button"
          class="p-button-secondary"
          (click)="onPreview()"
          [disabled]="isLoading || !inputText.trim()">
          <i
            class="pi pi-eye"
            aria-hidden="true"></i>
          プレビュー
        </button>
        <button
          pButton
          type="button"
          [loading]="isLoading"
          [disabled]="!canSubmit"
          (click)="onSubmit()"
          class="p-button-success">
          <i
            [class]="isLoading ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
            aria-hidden="true"></i>
          登録
        </button>
        <button
          pButton
          type="button"
          (click)="onClear()"
          [disabled]="isLoading"
          class="p-button-outlined">
          <i
            class="pi pi-times"
            aria-hidden="true"></i>
          クリア
        </button>
      </div>
    </div>
  </div>
</p-panel>

<!-- プレビュー: 有効行 -->
@if (parseResult && validCount > 0) {
  <div class="mt-4">
    <h4>登録対象 ({{ validCount }}件)</h4>
    <p-table
      [value]="parseResult.valid"
      class="p-datatable-sm p-datatable-striped"
      [paginator]="validCount > 20"
      [rows]="20">
      <ng-template #header>
        <tr>
          <th style="width: 80px">行番号</th>
          <th style="width: 140px">ASIN</th>
          <th>メモ</th>
          <th style="width: 80px">確率</th>
        </tr>
      </ng-template>
      <ng-template
        #body
        let-row>
        <tr>
          <td>{{ row.lineNo }}</td>
          <td>{{ row.input.asin }}</td>
          <td>{{ row.input.memo || '-' }}</td>
          <td>
            @if (row.input.probability != null) {
              {{ row.input.probability }}%
            } @else {
              -
            }
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
}

<!-- プレビュー: エラー行 -->
@if (parseResult && errorCount > 0) {
  <div class="mt-4">
    <h4 class="text-red-500">エラー行 ({{ errorCount }}件)</h4>
    <p-table
      [value]="parseResult.errors"
      class="p-datatable-sm"
      [paginator]="errorCount > 20"
      [rows]="20">
      <ng-template #header>
        <tr>
          <th style="width: 80px">行番号</th>
          <th style="width: 220px">理由</th>
          <th>元の行</th>
        </tr>
      </ng-template>
      <ng-template
        #body
        let-row>
        <tr>
          <td>{{ row.lineNo }}</td>
          <td>
            <p-tag
              severity="danger"
              [value]="row.reason"></p-tag>
          </td>
          <td>
            <code>{{ row.raw }}</code>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
}
